const TRACKER_TIME_ZONE = "Europe/Dublin";

const trackerVisitDateTimeFormatter = new Intl.DateTimeFormat("en-IE", {
    timeZone: TRACKER_TIME_ZONE,
    day: "numeric",
    month: "short",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
});

export function formatTrackerVisitDateTime(value: string): string {
    return trackerVisitDateTimeFormatter.format(new Date(value));
}
